<div
    #chartContainer
    class="agpr-chart agpr-cardChart"
    [agprLoading]="loading"
    [ngClass]="{
        'agpr-cardChart-responsive' : responsive,
        'agpr-cardChart-vertical': layout === cardChartComponentLayoutEnum.vertical,
        'agpr-cardChart-horizontal': layout === cardChartComponentLayoutEnum.horizontal,
        'volume': color === cardChartComponentHighlightColorEnum.volume,
        'ave': color === cardChartComponentHighlightColorEnum.ave,
        'impressions': color === cardChartComponentHighlightColorEnum.impressions,
        'engagements': color === cardChartComponentHighlightColorEnum.engagements,
        'averageDomainAuthority': color === cardChartComponentHighlightColorEnum.averageDomainAuthority,
        'applause': color === cardChartComponentHighlightColorEnum.applause,
        'conversation': color === cardChartComponentHighlightColorEnum.conversation,
        'amplification': color === cardChartComponentHighlightColorEnum.amplification,
        'positive': color === cardChartComponentHighlightColorEnum.positive,
        'negative': color === cardChartComponentHighlightColorEnum.negative,
        'neutral': color === cardChartComponentHighlightColorEnum.neutral,
        'other': color === cardChartComponentHighlightColorEnum.other,
        'blue': color === cardChartComponentHighlightColorEnum.blue,
        'purple': color === cardChartComponentHighlightColorEnum.purple,
        'lightBlue': color === cardChartComponentHighlightColorEnum.lightBlue,
        'lighterBlue': color === cardChartComponentHighlightColorEnum.lighterBlue,
        'orange': color === cardChartComponentHighlightColorEnum.orange,
        'yellow': color === cardChartComponentHighlightColorEnum.yellow,
        'lightGreen': color === cardChartComponentHighlightColorEnum.lightGreen,
        'green': color === cardChartComponentHighlightColorEnum.green,
        'teal': color === cardChartComponentHighlightColorEnum.teal,
        'aqua': color === cardChartComponentHighlightColorEnum.aqua,
        'coralPink': color === cardChartComponentHighlightColorEnum.coralPink,
        'crimson': color === cardChartComponentHighlightColorEnum.crimson,
        'lavender': color === cardChartComponentHighlightColorEnum.lavender,
        'mediumBlue': color === cardChartComponentHighlightColorEnum.mediumBlue,
        'darkPurple': color === cardChartComponentHighlightColorEnum.darkPurple,
        'agpr-cardChart-textAlignLeft': textAlignLeft,
        'disabled': disabled
    }"
    role="group"
    tabindex="0"
>
    @if (showCustomLabel) {
        <ng-content select="[card-chart-custom-label]"></ng-content>
    } @else {
        <div
            *ngIf="series[0]"
            class="agpr-cardChart-title"
            [ngClass]="{'agpr-cardChart-title-disabled': disabled}"
            [pTooltip]="tooltip | localize"
            tooltipPosition="bottom"
        >
            <span *ngIf="!headingLevel">{{ series[0].label | localize }}</span>
            <div *ngIf="headingLevel" role="heading" [attr.aria-level]="headingLevel">{{ series[0].label | localize }}</div>

            <span
                *ngIf="tooltipIconInfo"
                class="fa-regular fa-circle-info agpr-cardChart-infoIcon"
                [pTooltip]="tooltipIconInfo | localize"
                tooltipPosition="top"
                tabindex="0"
            ></span>
        </div>
    }
    @if (showCustomValue) {
        <ng-content select="[card-chart-custom-value]"></ng-content>
    } @else {
        <div
            class="agpr-cardChart-valueContainer"
            *ngIf="data && data.length >= 1 && data[0] && !disabled"
        >
            <div
                class="agpr-cardChart-number"
                [ngClass]="{
                    'agpr-cardChart-numberHorizontal': layout === cardChartComponentLayoutEnum.horizontal,
                    'agpr-cardChart-numberVertical': layout === cardChartComponentLayoutEnum.vertical
                }"
                [pTooltip]="data[0]?.count | number : '1.0-6'"
            >
                {{
                    showCurrency ? (((data[0].count || 0) | significantDigits: 1) | AppendCurrencyCode) :
                    isPercentage ? (((data[0].count || 0) | number : percentageFormat) + '%') :
                    numberOfDecimals ? (showNA ? ('na' | localize) : ((data[0]?.count || 0) | number : ('1.0-'+numberOfDecimals))) :
                    showNA ? ('na' | localize) : (data[0].count | significantDigits: 1)
                }}
            </div>
            <div
                *ngIf="!hidePrevious"
                class="agpr-cardChart-bubble"
                [ngClass]="{
                    'agpr-cardChart-bubbleRed': data[1]?.percent < 0,
                    'agpr-cardChart-bubbleGreen': data[1]?.percent > 0,
                    'agpr-cardChart-bubbleGrey': data[1]?.percent == 0,
                    'agpr-cardChart-bubbleNA': !data[1] || data[1].percent === undefined
                }"
                [agprTooltip]="bubbleTooltip"
            >
                <!-- Down arrow -->
                <span
                    *ngIf="data[1] && data[1]?.percent < 0"
                    class="fa-arrow-down-right fa-regular"
                    aria-hidden="true"
                >

                </span>
                <!-- Up arrow -->
                <span
                    *ngIf="data[1] && data[1]?.percent > 0"
                    class="fa-regular fa-arrow-up-right"
                    aria-hidden="true"
                >

                </span>
                    <span
                    *ngIf="data[1] && data[1]?.percent == 0"
                    class="agpr-cardChart-bubbleArrow"
                    aria-hidden="true"
                >
                   -
                </span>
                <span *ngIf="data[1] && data[1].percent" aria-hidden="true">{{ data[1]?.percent }}%</span>
                <span *ngIf="!data[1] || !data[1].percent" aria-hidden="true">--%</span>
            </div>
        </div>
    }
    <div
        *ngIf="disabled"
        class="agpr-cardChart-disabled"
    >
        -
    </div>
    <div
        *ngIf="error"
        class="agpr-dataListChart-error"
    >
        {{ error.message | localize}}
    </div>
</div>
